var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.998,
    height: 35,
    viewBox: "0 0 34.998 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3190",
    "data-name": "Group 3190",
    transform: "translate(549.775 -151.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4612",
    "data-name": "Path 4612",
    d: "M-532.264,151.106a17.537,17.537,0,0,1,17.487,17.52,17.54,17.54,0,0,1-17.529,17.479,17.54,17.54,0,0,1-17.468-17.54A17.538,17.538,0,0,1-532.264,151.106Zm-.018,3.188a14.322,14.322,0,0,0-14.306,14.29,14.325,14.325,0,0,0,14.3,14.334,14.324,14.324,0,0,0,14.324-14.309A14.32,14.32,0,0,0-532.282,154.293Z",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4613",
    "data-name": "Path 4613",
    d: "M-466.907,231.113l5.766-.839c.564-.082,1.128-.167,1.693-.237a.551.551,0,0,0,.462-.36q1.559-3.189,3.136-6.368c.059-.119.125-.235.222-.415.091.173.158.3.221.424,1.043,2.11,2.09,4.218,3.12,6.334a.643.643,0,0,0,.557.4q3.68.524,7.358,1.064c.007,0,.013.017.037.052-.076.081-.154.171-.239.254q-2.572,2.513-5.15,5.021a.511.511,0,0,0-.176.516c.37,2.111.728,4.224,1.089,6.336.064.373.125.747.2,1.185-1.123-.588-2.186-1.144-3.248-1.7-1.163-.611-2.327-1.219-3.483-1.842a.54.54,0,0,0-.578.006q-3.136,1.664-6.282,3.31c-.129.068-.262.127-.446.216.145-.856.28-1.66.418-2.463.286-1.66.568-3.321.865-4.98a.638.638,0,0,0-.228-.642c-1.688-1.631-3.364-3.275-5.046-4.914-.1-.095-.211-.173-.317-.258Zm15.675,2.207c-.826-.118-1.694-.253-2.566-.362a.665.665,0,0,1-.617-.428c-.186-.445-.417-.871-.632-1.3-.183-.369-.371-.737-.588-1.167-.429.868-.835,1.659-1.207,2.464a.691.691,0,0,1-.613.434c-.877.114-1.752.251-2.6.375a14.969,14.969,0,0,0,1.343,1.4,1.509,1.509,0,0,1,.63,1.9,1.377,1.377,0,0,0-.052.292c-.091.555-.182,1.109-.285,1.74.9-.471,1.723-.9,2.538-1.336a.46.46,0,0,1,.506,0c.518.29,1.048.561,1.575.836.3.156.6.306.927.472a1.985,1.985,0,0,0,0-.276c-.134-.781-.257-1.564-.413-2.34a.761.761,0,0,1,.242-.783C-452.424,234.62-451.839,233.965-451.232,233.32Z",
    transform: "translate(-76.645 -66.437)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.61b8e5997a328a9ee488d3c76784e1f0.svg";
export { ForwardRef as ReactComponent };